module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("socialnetwork_oauth_signin", [["a",{"class":"soc-button &&0&&","data-app-name":"","data-request-url":""},[["if",{"notempty":"","addclass":"blue-btn"},[],[["alias","notempty",true,[{"name":"eq","params":["twitter"]}]]]],["span",{"class":"fcup"},[["span",{},[],[["alias","__text",true]]]]]],[["alias","class"],["alias","data-app-name",true],["requestUrl","data-request-url",true]]]]);
fox.registerTemplate("socialnetwork_oauth_signin_container", [["div",{"id":"items-block","class":"soc-buttons"}]]);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-dynamic-injection!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-template-loader?interpolate!../common/templates/socialnetwork/oauth.tpl
// module id = 32
// module chunks = 2